
<div *ngIf="shouldDisplayAnyStages" [formGroup]="form">
    <div class="alert mt-3 {{additionalClass}}" role="info" formArrayName="Stages">
        <button type="button"
                class="btn btn-link w-100 text-start p-0 border-0"
                (click)="toggle()"
                [attr.aria-expanded]="expanded"
                [attr.aria-controls]="'approval-stages-' + uniqueId"
                aria-label="Toggle approval stages">
            <span class="form-label d-inline">{{ title }}</span>
            <i class="fas ms-2"
               [class.fa-angle-down]="expanded"
               [class.fa-angle-up]="!expanded"
               aria-hidden="true"></i>
        </button>
        <div *ngIf="expanded" [id]="'approval-stages-' + uniqueId">
            <hr>
            <label class="form-label">Select the approvers for the following approval stages: (Optional)</label>
            <ul *ngFor="let verificationStage of verificationStages; let i=index">
                <li *ngIf="shouldDisplayStages[i]" [formGroupName]="i">
                    <div class = "form-group">
                        <ng-template [ngIf]="verificationStage.Approvers.length == 1 && !verificationStage.IsSkippable" [ngIfElse]="elseBlock">
                            <edl-floating-label-container [label]="verificationStage.StageName" [for]="'approverSelect-' + i"  >
                                <select [id]="'approverSelect-' + i" class="form-select" [disabled]="true">
                                    <option [ngValue]="null">{{verificationStage.Approvers[0].DisplayName}}</option>
                                </select>
                            </edl-floating-label-container>
                        </ng-template>

                            <ng-template #elseBlock>
                            <edl-floating-label-container [label]="verificationStage.StageName" [for]="'approverSelect-' + i"  >
                                <select [id]="'approverSelect-' + i" class="form-select" (change)="onApproverChanged()" formControlName="SelectedUserId">
                                    <option [ngValue]="TargetEvaluator.ALL">All</option>
                                    <option *ngIf="verificationStage.IsSkippable && reopenStageId !== verificationStage.StageID"
                                        [ngValue]="TargetEvaluator.SKIP">Bypass Approval</option>
                                    <option *ngFor="let approver of verificationStage.Approvers" [ngValue]="approver.UserID">{{approver.DisplayName}}</option>
                                </select>
                            </edl-floating-label-container>
                        </ng-template>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>